import React, { forwardRef, useState } from 'react';
import { More } from '@wix/wix-ui-icons-common/on-stage';
import { IconButton } from '@wix/wix-ui-tpa/cssVars';
import ItemActionsMenu from './ItemActionsMenu/ItemActionsMenu';
import { setMenuSelectedItem } from '../../../../../../Services/MenuSelectedItem';
import { classes, st } from './ItemActions.st.css';
import withClickOutsideListener from '../../../../../../../Shared/HOC/withClickOutsideListener';
import MoveWrapper from '../../../../../../Shared/MoveWrapper/MoveWrapper';

const ItemActions = forwardRef((props: any, ref: any) => {
  const { item, open, setOpen } = props;
  const [showMenu, setShowMenu] = useState({
    showMenu: false,
    showMove: false,
  });
  const handleOnClick = async () => {
    setOpen(!open);
    setShowMenu((prevState: any) => ({
      ...prevState,
      showMenu: !open,
      showMove: false,
    }));
    await setMenuSelectedItem(item);
  };
  const handleOpenMove = () => {
    // setMoveLoader(true);
    setShowMenu((prevState: any) => ({
      ...prevState,
      showMenu: false,
      showMove: true,
    }));
  };
  const handleOnCloseMove = () => {
    setShowMenu((prevState: any) => ({
      ...prevState,
      showMenu: false,
      showMove: false,
    }));
  };
  return (
    <div ref={ref}>
      <IconButton
        aria-label="more actions"
        type="button"
        aria-haspopup="menu"
        aria-expanded={open ? open && showMenu.showMenu : false}
        className={st(classes.iconButton)}
        icon={<More />}
        onClick={handleOnClick}
      />

      {open && (
        <div>
          {showMenu.showMenu && (
            <ItemActionsMenu
              item={item}
              setOpen={setOpen}
              handleOpenMove={handleOpenMove}
            />
          )}
          {showMenu.showMove && (
            <MoveWrapper handleOnCloseMove={handleOnCloseMove} />
          )}
        </div>
      )}
    </div>
  );
});

export default withClickOutsideListener(ItemActions);
